import "./HomeSection.css";
import Logo from "../../assets/indianarmylogo.png";
import { useNavigate } from "react-router-dom";
import { FiDownload } from "react-icons/fi";
function HomeSection() {
  const navigate = useNavigate();

  const handleStudyMaterialDownload = async () => {
    const url =
      "https://assets.quizcatalyst.com/indianarmy/ResultsArmyQuiz.pdf";
    const fileName = "ResultsArmyQuiz.pdf";

    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);
      window.open(url, "_blank");
    }
  };

  return (
    <section id="home" className="home-section">
      <div className="home-center">
        <div className="header-text">
          <p className="directorate-text">Directorate General of Recruiting</p>
          <p className="presents-text">Presents</p>
        </div>
        <div className="logo-cloud">
          <img src={Logo} alt="logo" className="logo-image" />
        </div>
        <p className="main-hashtag">#JoinIndianArmy</p>
        <div className="main-buttons">
          <button
            className="main-btn study-material"
            onClick={() => navigate("/certificate")}
          >
            <FiDownload className="download-icon" />
            Download Certificate
          </button>
        </div>
        <button
          className="main-btn study-material"
          onClick={handleStudyMaterialDownload}
        >
          <FiDownload className="download-icon" />
          Result Download
        </button>
        <p className="main-subtitle">
          Online Prelim Results will be announced on 2 Feb at 6PM
        </p>
      </div>
    </section>
  );
}

export default HomeSection;
